const { createSlice } = require("@reduxjs/toolkit");
const collectionPageSlice = createSlice({
  name: "collectionPage",
  initialState: {
    collectionPageNo: 1,
    collectionId: "",
  },
  reducers: {
    setcollectionPage(state, action) {
      const collectionPageNo = action.payload;
      return (state = {
        collectionPageNo,
      });
    },
    setcollectionId(state, action) {
      const collectionId = action.payload;
      return (state = {
        collectionId,
      });
    },
  },
});
export const { setcollectionPage, setcollectionId } =
  collectionPageSlice.actions;
export default collectionPageSlice.reducer;